import type { FaireProductEntity } from "../../entity_types/product";

export const p_3jvqysrtg8: FaireProductEntity = {
  token: "p_3jvqysrtg8",
  type: "product",
  name: "GINGHAM SHIRRING DETAILED MAXI DRESS - 6547D",
  brandToken: "b_8tg8mxotwp",
  brandName: "PINCH",
  imageUrl:
    "https://cdn.faire.com/fastly/da42eb54ba851653ffbab1034597f5cffaa4754b361b2992e3352d5856bbed4d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6c9bd8a790dba086b43ffc322ca3f849021c82329dcd1da81c652ef77b4c821.jpeg",
    "https://cdn.faire.com/fastly/71a2a91dcc114daf802fb0bd4dfa78a98410e781c0cb0afc78996c2fb41b91ba.jpeg",
    "https://cdn.faire.com/fastly/88089772678281ed4707b309f1e39d468c9bcc309f519d896876c9d0f878b38a.jpeg",
    "https://cdn.faire.com/fastly/c93191b0bd3a582211c1688a2b74dac0a5f5abc481a3b25dcef8efc864a596cd.jpeg",
    "https://cdn.faire.com/fastly/390426367fd00209eb5427b5e3e67c3e4a998cc1de4302db91c7b005faffbb24.jpeg",
    "https://cdn.faire.com/fastly/2518ac64360ad9d3a0f558b4bb4c7143679d3b5f147a43fc1d55a393bcd9238f.jpeg",
    "https://cdn.faire.com/fastly/f68c9a81a61619d6e275a2d6b723c5db6b0792453ebd839a6a94b29b2b5b2ed1.jpeg",
    "https://cdn.faire.com/fastly/6bb8a2d6d6de8d6754be0ee517cddcb975d78134e896aa8858dfea301e524f4f.jpeg",
    "https://cdn.faire.com/fastly/150dba4c73d445b891245665155fdb40e24b98168df123c2ea606b01fd8a4819.jpeg",
    "https://cdn.faire.com/fastly/611f29fe5d956c9c88d0bb4e4b10eb4c8f76bbb110edb9695f64532664e6efd1.jpeg",
    "https://cdn.faire.com/fastly/2e20271bbc5f35ce650ce1ff76b16a551e63629ce8371fe18efb5f117e197dd7.jpeg",
    "https://cdn.faire.com/fastly/fc96301ab136f0095f4c5c486dcfcfe10ca0219526eac68e327bd331341211f9.jpeg",
  ],
  priceDollars: 244.5,
  description:
    "• Round Neck With Ruffle\n• Shrring Elastic Detail\n• Tiered Detail\n• Sleeveless\n• Maxi Length\n\nModel Wears A Size Small",
  tags: [],
  msrpDollars: 489,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:46.051Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
